"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CarouselSkeleton;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@linaria/core");
var _commonStyles = require("../styles/commonStyles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const carouselClassName = "c1yzgw1p";
const Card = _ref => {
  let {
    idx
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'skeletonCard',
    key: `skeleton-card-${idx}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cardImageContainer"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)('cardImage')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)('cardImage')
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "cardTextContainer"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.accountTabsCardTextBg, 'cardText')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.accountTabsCardTextBg, 'cardText')
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _core.cx)(_commonStyles.accountTabsCardTextBg, 'cardText')
  })));
};
Card.propTypes = {
  idx: _propTypes.default.number
};
const cards = [...new Array(3)].map((_, idx) => {
  return /*#__PURE__*/_react.default.createElement(Card, {
    key: idx,
    idx: idx
  });
});
function CarouselSkeleton(_ref2) {
  let {
    className
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _core.cx)(carouselClassName, className)
  }, cards);
}
CarouselSkeleton.propTypes = {
  className: _propTypes.default.string
};